export const stockDomain = {
    dev: '//test-stock.9fzt.com',
    test: '//test-stock.9fzt.com',
    production: '//stock.9fzt.com',
}[process.env.NODE_ENV];

export const gwDomain = {
    dev: '//test-wap.9fzt.com',
    test: '//test-wap.9fzt.com',
    production: '//wap.9fzt.com',
}[process.env.NODE_ENV];

export const pcDomain = {
    dev: '//test-www.9fzt.com',
    test: '//test-www.9fzt.com',
    production: '//www.9fzt.com',
}[process.env.NODE_ENV];

export const fundDomain = {
    dev: '//test-fund.9fzt.com',
    test: '//test-fund.9fzt.com',
    production: '//fund.9fzt.com',
}[process.env.NODE_ENV];
